import ProviderListViewController from "./provider-list-view-controller";

class NewProviderListViewController extends ProviderListViewController {
  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  updateValue(event) {
    event.preventDefault();
    const { value } = event.target;

    if (this.appData?.setFilters) {
      this.appData.setFilters({ search: value });
    }
  }

  preprocessAppData() {
    this.appData.updateValue = this.updateValue.bind(this);
    super.preprocessAppData();
  }
}

export default NewProviderListViewController;
